<div class="input-group">
    <p class="f-11 font-weight-600" [ngClass]="{'color-light-grey-disabledType': to.disabled}">
      {{field.templateOptions.label}}<span *ngIf="to.required" class="color-red">*</span>
    </p>
    <textarea draggable="true" autosize id="{{ 'txtarea' + fieldKey }}" [readonly]="to.readonly" 
      [formControl]="formControl" [formlyAttributes]="field"
      class="form-control has-value border w-100pc p-1 my-1 min-h-5em" style="resize: vertical;"
      [ngClass]="{'has-value': formControl.value,'color-light-grey-disabledType': to.disabled }" (input)="onTextInput()">
    </textarea>
    <div *ngIf="formControl.errors && formControl.errors.required && isFormSubmitted" class="alert-danger">
        <span *ngIf="!formControl.value || !formControl.value.trim()">
            <b>{{ "label_Required" | translate: param }}</b>
        </span>
    </div>
    <p  *ngIf="field.templateOptions.note && field.templateOptions.note && field.templateOptions.maxLength && field.templateOptions.maxLengthCount">
      <small class="text-left" *ngIf="field.templateOptions.note && field.templateOptions.note">
          {{field.templateOptions.note}}
      </small>
      <small class="fa-pull-right" *ngIf="field.templateOptions.maxLength && field.templateOptions.maxLengthCount" >
          {{formControl.value ? formControl.value.length : 0}} / {{ field.templateOptions.maxLength}}
      </small>     
    </p>
</div>
